import { PureComponent } from 'react';
import { View } from 'react-native';
import { Text } from '@symbolic/rn-lib';
import { getLogoForOrg } from '~/helpers/get-logo-for-org';
import { getShouldRenderElementForOrg } from '../helpers/get-should-render-helpers';

import K from '~/k';
import moment from 'moment';

class PageHeader extends PureComponent {

  render() {
    var {pageNumber, pageCount, productOrder, renderForDrawings, activeOrgId} = this.props;

    return (<>
      <View style={{position: 'absolute', bottom: K.spacing * 3, left: K.spacing * 3}}>
        {/* <img //WARNING react image causes blurry logo in pdf
          src={getLogoForOrg({orgId: activeOrgId, colorVariant: 'black'})}
          style={{width: Math.round(K.calc(200))}}
        /> */}
        {!!renderForDrawings && getShouldRenderElementForOrg({activeOrgId, visibleOrgIds: [850]}) && (
          <Text style={{fontStyle: 'italic', opacity: 0.6, fontSize: 11, width: 400, paddingTop: 5}}>{`Submittal drawings are provided for order coordination and confirmation purposes only and are not guaranteed to exact specifications. Drawings closely represent the final product; however, slight variations may exist related to engraving and component sizing and spacing.`}</Text>
        )}
      </View>
      <View style={{position: 'absolute', bottom: K.spacing * 3, right: K.spacing * 3, alignItems: 'flex-end', textAlign: 'right'}}>
        <Text style={{...K.fonts.label, textTransform: 'none'}}>Order #{productOrder.orgSpecificId}</Text>
        <Text style={{...K.fonts.label}}>{moment(productOrder.lastUpdated).format('M/D/YYYY')}</Text>
        <Text style={{...K.fonts.label}}>Page {pageNumber + 1} of {pageCount}</Text>
      </View>
    </>);
  }
}

export default PageHeader;
